import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../api/api";

// Async thunk for fetching admin details
export const fetchAdminDetails = createAsyncThunk(
  "admin/fetchDetails",
  async (adminId, { rejectWithValue }) => {
    try {
      const res = await request({
        url: "/admin/admin/details",
        method: "POST",
        data: { adminId }
      });

      if (res.status === 1) {
        return res.response.permissions;
      } else {
        return rejectWithValue(res);
      }
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    permissions: localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) ?? [] :[],
    loading: false,
    error: null
  },
  reducers: {
    clearAdminData: (state) => {
      state.permissions = [];
      state.error = null;
      localStorage.removeItem("permissions");
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdminDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
        localStorage.setItem("permissions", JSON.stringify(action.payload)??[]);
      })
      .addCase(fetchAdminDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearAdminData } = adminSlice.actions;
export default adminSlice.reducer;
